/* eslint-disable css-modules/no-unused-class, no-nested-ternary  */
import { FC, useEffect, useState } from 'react';
import styles from './category.module.scss';

const CategoryCard: FC<CategoryCardProps> = (props: CategoryCardProps) => {
    const { name, description, imageSrc, onClick, isSelected } = props;
    const [isHovered, setIsHovered] = useState(false);

    useEffect(() => {
        if (isSelected) {
            setIsHovered(false);
        }
    }, [isSelected]);

    return (
        <div
            className={
                styles[isSelected ? 'selected-category-card' : isHovered ? 'hovered-category-card' : 'category-card']
            }
            onClick={onClick}
            onMouseEnter={() => (isSelected ? undefined : setIsHovered(true))}
            onMouseLeave={() => setIsHovered(false)}
        >
            {imageSrc && (
                <div className={styles.image}>
                    <img src={imageSrc} alt={name} className={styles.img} />
                </div>
            )}
            <div className={styles.texts}>
                <div className={styles.name}>{name}</div>
                {isHovered && description && !isSelected && <div className={styles.description}>{description}</div>}
            </div>
        </div>
    );
};

export default CategoryCard;

interface CategoryCardProps {
    name: string;
    description?: string;
    imageSrc?: string;
    onClick: () => void;
    isSelected?: boolean;
}
